import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Footer from './Footer';

export default function AppShell({ children, currentPath }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[var(--bg)] text-[var(--text)] flex flex-col">
      <div className="flex flex-1 min-h-0">
        {/* Sidebar - Desktop */}
        <aside className="hidden lg:block w-[280px] border-r border-[var(--border)] bg-[var(--card)] sticky top-0 h-screen overflow-y-auto">
          <Sidebar currentPath={currentPath} />
        </aside>

        {/* Sidebar - Mobile Drawer */}
        {sidebarOpen && (
          <div className="lg:hidden fixed inset-0 z-50">
            <div 
              className="absolute inset-0 bg-black/50"
              onClick={() => setSidebarOpen(false)}
            />
            <aside className="absolute left-0 top-0 bottom-0 w-[280px] bg-[var(--card)] border-r border-[var(--border)] overflow-y-auto">
              <Sidebar currentPath={currentPath} onClose={() => setSidebarOpen(false)} />
            </aside>
          </div>
        )}

        {/* Main Content */}
        <main className="flex-1 min-w-0 flex flex-col">
          <Topbar onMenuClick={() => setSidebarOpen(true)} />
          
          <div className="flex-1 overflow-y-auto">
            <div className="px-4 py-6 sm:px-6 lg:px-8">
              <div className="mx-auto max-w-[1200px]">
                {children}
              </div>
            </div>
          </div>

          <Footer />
        </main>
      </div>
    </div>
  );
}
